

  // This file was autogenerated by dynamically running setEnv.ts and using dotenv for managing API key secrecy
  import { EnvironmentVariables } from './environment-variables';

  export const environment: EnvironmentVariables = {
    FIREBASE_API_KEY: 'AIzaSyCso1ZiXgh8ZhO4ff-zd9L2gxdOTSr9MlY',
    PIPELINE_STAGE: 'prod'
  };

